import { PolfEventRankingEnum } from '@polf/shared/codegen/types'
import type { ReactNode } from 'react'

/**
 * Which figure the board ranks on.
 *
 * Not a gloss on what net or stableford mean — a golfer knows. The one thing
 * a column of numbers cannot say is which of the two it prints is the one
 * being ranked, and that is a word, not a sentence.
 */
export const scoringNote = (
  ranking?: PolfEventRankingEnum | null
): string | null => {
  if (ranking === PolfEventRankingEnum.NetStrokes) return 'Netto slag'
  if (ranking === PolfEventRankingEnum.Stableford) return 'Stableford'
  return null
}

/**
 * Title row + live ticker — every variant uses the same scaffolding.
 * The `controls` slot is where the variant slots in its toggle (or
 * leaves empty for flat-list variants).
 */
const Header = ({
  controls,
  scoring,
}: {
  controls?: ReactNode
  /** One word naming the ranked figure. See `scoringNote`. */
  scoring?: ReactNode
}) => (
  <div className="px-4 pt-3 pb-2 flex items-baseline justify-between gap-3">
    <h1 className="font-display text-xl font-bold text-green-900">
      Leaderboard
    </h1>
    <div className="flex items-baseline gap-3 min-w-0">
      {scoring ? (
        <span className="text-[11px] text-ink-500 truncate">{scoring}</span>
      ) : null}
      {controls ?? null}
    </div>
  </div>
)

export default Header
